<template>
  <b-modal
    title="ویرایش زمان برای زبان آموز VIP"
    id="modal-vip-reserve-update"
    centered
    ok-title="بروزرسانی"
    cancel-title="بستن"
    ok-variant="success"
    @ok="updateASingleVipUserReserve"
  >
    <b-container fluid v-if="vipUserReserveDetails">
      <vip-user-picker
        :defaultUserId="vipUserReserve.userId"
        @getUserId="setUserId"
      ></vip-user-picker>

      <div class="d-flex align-items-center mb-1">
        <p class="mb-0 mr-1">از:</p>
        <b-input-group class="input-group-merge">
          <b-form-input
            :value="createJalaliHour(vipUserReserveDetails.startDate)"
            :id="`startTime`"
            :class="`startTime`"
            placeholder="از ساعت"
          ></b-form-input>
          <b-input-group-append is-text>
            <feather-icon class="cursor-pointer" icon="ClockIcon" size="18" />
            <date-picker
              v-model="vipUserReserveDetails.startDate"
              :customInput="`.startTime`"
              :jumpMinute="10"
              :roundMinute="true"
              format="YYYY-MM-DD HH:mm:ss"
              display-format="HH:mm"
              type="time"
            ></date-picker>
          </b-input-group-append>
        </b-input-group>
      </div>
      <div class="d-flex align-items-center mb-1">
        <p class="mb-0 mr-1">تا:</p>
        <b-input-group class="input-group-merge">
          <b-form-input
            :value="createJalaliHour(vipUserReserveDetails.endDate)"
            :id="`endTime`"
            :class="`endTime`"
            placeholder="تا ساعت"
          ></b-form-input>
          <b-input-group-append is-text>
            <feather-icon class="cursor-pointer" icon="ClockIcon" size="18" />
            <date-picker
              v-model="vipUserReserveDetails.endDate"
              :customInput="`.endTime`"
              :jumpMinute="10"
              :roundMinute="true"
              format="YYYY-MM-DD HH:mm:ss"
              display-format="HH:mm"
              type="time"
            ></date-picker>
          </b-input-group-append>
        </b-input-group>
      </div>
      <div class="d-flex align-items-center mb-1">
        <p class="mb-0 mr-1" style="white-space: nowrap">تاریخ انقضاء:</p>
        <b-input-group class="input-group-merge">
          <b-form-input
            :value="createJalaliDate(vipUserReserveDetails.expireTime)"
            id="expireTime"
            class="expireTime"
            placeholder="تاریخ انفضاء"
          ></b-form-input>
          <b-input-group-append is-text>
            <feather-icon class="cursor-pointer" icon="ClockIcon" size="18" />
            <date-picker
              v-model="vipUserReserveDetails.expireTime"
              customInput=".expireTime"
              :jumpMinute="10"
              :roundMinute="true"
              format="YYYY-MM-DD HH:mm:ss"
              display-format="jYYYY-jMM-jDD HH:mm"
              type="datetime"
            ></date-picker>
          </b-input-group-append>
        </b-input-group>
      </div>
    </b-container>
  </b-modal>
</template>
<script>
export default {
  emits: ["updateMasterPeriods"],
  props: {
    scheduleDetails: {
      type: Object,
      required: true,
    },
    vipUserReserve: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.getASingleVipReserve();
  },
  data() {
    return {
      vipUserReserveDetails: null,
    };
  },
  methods: {
    createJalaliDate(date) {
      const myCustomDate = new Date(date).toLocaleDateString("fa-IR");
      const myCustomTime = new Date(date).toLocaleTimeString("fa-IR", {
        hour: "2-digit",
        minute: "2-digit",
      });
      return `${myCustomDate} - ${myCustomTime}`;
    },
    createJalaliHour(date) {
      return new Date(date).toLocaleTimeString("fa-IR", {
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    synchronizeVipDateWithScheduleDate() {
      // Set Start and end of vipUserReservationDetails
      // To Selected schedule Date
      this.vipUserReserveDetails.startDate = new Date(
        new Date(this.vipUserReserveDetails.startDate).setDate(
          new Date(this.scheduleDetails.startTime).getDate()
        )
      ).toISOString();
      this.vipUserReserveDetails.endDate = new Date(
        new Date(this.vipUserReserveDetails.endDate).setDate(
          new Date(this.scheduleDetails.endTime).getDate()
        )
      ).toISOString();
    },
    setUserId(userId) {
      this.vipUserReserveDetails.userId = userId;
    },
    async getASingleVipReserve() {
      try {
        this.isLoading = true;
        let _this = this;
        let getVipUserReserveById = new GetVipUserReserveById(_this);
        getVipUserReserveById.setRequestParam({
          id: _this.vipUserReserve.vipUserReserveId,
        });
        await getVipUserReserveById.fetch((res) => {
          _this.vipUserReserveDetails = res;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async updateASingleVipUserReserve() {
      this.vipUserReserveDetails.expireTime = new Date(
        this.vipUserReserveDetails.expireTime
      ).toISOString();
      this.synchronizeVipDateWithScheduleDate();
      try {
        this.isLoading = true;
        let _this = this;
        let updateVipUserReserve = new UpdateVipUserReserve(_this);
        updateVipUserReserve.setRequestParamDataObj(
          _this.vipUserReserveDetails
        );
        await updateVipUserReserve.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ویرایش شد",
                icon: "CheckIcon",
                variant: "success",
                text: "زمانبندی با موفقیت ویرایش شد",
              },
            });
            _this.$emit("updateMasterPeriods");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "مشکلی پیش آمد!",
                icon: "XIcon",
                variant: "danger",
                text: res.message || "لطفا دوباره امتحان کنید!",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    BCard,
    BCollapse,
    BCardText,
    BCardHeader,
    BButton,
    BBadge,
    BModal,
    BContainer,
    VipUserPicker,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
  },
};
import {
  GetVipUserReserveById,
  UpdateVipUserReserve,
} from "@/libs/Api/VipUserReserve";
import {
  BCard,
  BCollapse,
  BCardText,
  BCardHeader,
  BButton,
  BBadge,
  BModal,
  BContainer,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
} from "bootstrap-vue";
import VipUserPicker from "@/views/components/VipUser/VipUserPicker.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
</script>
